import { CheckboxListOption } from 'components/Form/CheckboxListFilterable'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { domainsFromDTO, DomainSliceDTO, GET_DOMAINS_FOR_FILTERING_RULE } from './api'
import { Data, Variables } from './api/types'
import { UseGetDomainsOptions } from './types'

export const useGetDomainsOptions = (): UseGetDomainsOptions => {
  const { workspaceId } = useWorkspaceParam()

  const { data, isLoading } = useQuery<Variables, Data, CheckboxListOption[]>({
    options: {
      select: ({ domains: { nodes } }: Data): CheckboxListOption[] =>
        nodes?.map((node: DomainSliceDTO): CheckboxListOption => domainsFromDTO(node)) ?? [],
    },
    query: GET_DOMAINS_FOR_FILTERING_RULE,
    variables: {
      workspaceId,
    },
  })

  return {
    domainsOptions: data ?? [],
    loading: isLoading,
  }
}
